import React, { Component } from 'react'
import 'react-vis/dist/style.css'
import { OrdinalFrame } from 'semiotic'
import * as moment from 'moment'
import { withStyles } from 'material-ui/styles'
import { Button, Grid } from 'material-ui'
import IconButton from 'material-ui/IconButton'
import ChevronLeftIcon from 'material-ui-icons/ChevronLeft'
import ChevronRightIcon from 'material-ui-icons/ChevronRight'

const styles = theme => ({
  tooltipContent: {
    background: 'white',
    border: 1,
    color: 'black',
    padding: 10
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200
  }
})

var minTime = moment()
var maxTime = moment()
var action = ''

@withStyles(styles)
export default class AlchemySleepWeekly extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dateSeleted: new Date(moment())
        .toISOString('yyyy-MM-dd')
        .substring(0, 10),
      yearweekNo: moment()
        .endOf('week')
        .format('l')
    }
    this.nextWeek = this.nextWeek.bind(this)
    this.prevWeek = this.prevWeek.bind(this)
    this.setToday = this.setToday.bind(this)
  }

  setToday = () => {
    this.setState({
      yearweekNo: moment()
        .endOf('week')
        .format('l')
    })
  }

  timelineSleep = ({ data, rScale, adjustedSize, margin }) => {
    const renderedPieces = []

    const keys = Object.keys(data)

    keys.forEach(key => {
      //Only one piece of data per column though we'll render multiple graphical elements
      const column = data[key]
      const sleep = column.pieceData[0]

      //You can return an array of graphics or an array of objects with extra data (see the Waterfall chart demo)
      const markObject = (
        <g
          key={`piece-${key}`}
          cursor={
            moment(new Date(sleep.data.date)).isAfter(moment(), 'day')
              ? 'auto'
              : 'pointer'
          }
          onClick={
            moment(new Date(sleep.data.date)).isAfter(moment(), 'day') ||
            action === ''
              ? () => {
                  console.log('action to add')
                }
              : () => {
                  sleep.data.type === 'blank'
                    ? action(sleep.data.date, 'add')
                    : action(sleep.data.date, 'other')
                }
          }
        >
          {column.pieceData.map((s, index) => (
            <g key={`stack-rect-${index}`}>
              <rect
                key={`rect-${key}`}
                fill={
                  moment(new Date(s.data.date)).isAfter(moment(), 'day')
                    ? 'rgba(253, 253, 253,0)'
                    : s.data.type === 'blank' ? '#f2f2f2' : 'lightblue'
                }
                stroke={
                  moment(new Date(s.data.date)).isSame(moment(), 'day')
                    ? 'rgba(0,250,154,0.3)'
                    : ''
                }
                opacity={0.8}
                width={column.width}
                height={
                  rScale(new Date(s.data.barEnd)) -
                  rScale(new Date(s.data.barStart))
                }
                x={column.x}
                y={
                  rScale(maxTime) -
                  rScale(new Date(s.data.barEnd)) +
                  rScale(minTime)
                }
                rx={3}
                ry={3}
              />
              {new Date(s.data.barEnd) <=
                moment(moment(new Date(this.state.yearweekNo)))
                  .day('monday')
                  .hour('7')
                  .minute('0')
                  .second('0') && s.data.type !== 'blank' ? (
                <text
                  key={`piece-${key}`}
                  x={column.x + column.width / 2 - adjustedSize[0] / 64}
                  y={
                    rScale(maxTime) -
                    rScale(new Date(s.data.barEnd)) +
                    rScale(minTime) +
                    adjustedSize[0] / 22
                  }
                  fontSize={adjustedSize[0] / 30}
                  fill={'white'}
                >
                  ★
                </text>
              ) : (
                <text key={`text-${key}`} />
              )}
            </g>
          ))}
        </g>
      )

      renderedPieces.push(markObject)
    })

    return renderedPieces
  }

  prevWeek = () => {
    const prevWeekNo = moment(new Date(this.state.yearweekNo)).subtract(
      1,
      'week'
    )
    this.setState({
      yearweekNo: prevWeekNo.endOf('week').format('l')
    })
  }

  nextWeek = () => {
    const nextWeekNo = moment(new Date(this.state.yearweekNo)).add(1, 'week')
    this.setState({
      yearweekNo: nextWeekNo.endOf('week').format('l')
    })
  }

  addBlankDate = data => {
    var iDateStart = moment(new Date(this.state.yearweekNo)).startOf('week')
    var iDateEnd = moment(new Date(this.state.yearweekNo)).endOf('week')
    var daysWeek = iDateEnd.diff(iDateStart, 'days') + 1

    for (var i = 0; i < daysWeek; i++) {
      var blankDate = iDateStart
      var isSame = false

      for (var j in data) {
        if (
          moment(new Date(data[j].date)).format('l') === blankDate.format('l')
        ) {
          isSame = true
        }
      }
      if (!isSame) {
        data.splice(i, 0, {
          date: blankDate.format('l'),
          barStart: moment(new Date(blankDate.toDate()))
            .day('sunday')
            .hour('23')
            .minute('0')
            .second('0')
            .format('MM/DD/YYYY HH:mm'),
          barEnd: moment(new Date(blankDate.toDate()))
            .day('monday')
            .hour('7')
            .minute('0')
            .second('0')
            .format('MM/DD/YYYY HH:mm'),
          type: 'blank'
        })
        isSame = false
      }

      iDateStart = moment(blankDate).add(1, 'd')
    }

    return data
  }

  render() {
    const { classes } = this.props
    const tmp = this.props.data
    const dataSleepWeekly = tmp.filter(
      sleep =>
        moment(new Date(sleep.date))
          .endOf('week')
          .format('l') === this.state.yearweekNo
    )
    var dataChartSleepWeekly = []
    const sleepDays = dataSleepWeekly.length

    for (var i = 0; i < sleepDays; i++) {
      const sleepDurationHour =
        dataSleepWeekly[i].timeStart === ''
          ? 0
          : moment(new Date(dataSleepWeekly[i].timeComplete)).diff(
              moment(new Date(dataSleepWeekly[i].timeStart)),
              'hours'
            )
      const sleepDurationMin = moment
        .utc(
          moment(
            new Date(dataSleepWeekly[i].timeComplete),
            'MM/DD/YYYY HH:mm'
          ).diff(
            moment(new Date(dataSleepWeekly[i].timeStart), 'MM/DD/YYYY HH:mm')
          )
        )
        .format('mm')

      const barEndTime = moment(new Date(dataSleepWeekly[i].timeComplete))
        .day('monday')
        .format('MM/DD/YYYY HH:mm')

      dataChartSleepWeekly.splice(
        moment(new Date(dataSleepWeekly[i].date)).day(),
        0,
        {
          date: moment(new Date(dataSleepWeekly[i].date)).format('l'),
          barStart:
            sleepDurationHour === 0
              ? moment(new Date(barEndTime))
                  .subtract(1, 'hour')
                  .subtract(0, 'minute')
                  .format('MM/DD/YYYY HH:mm')
              : moment(new Date(barEndTime))
                  .subtract(sleepDurationHour, 'hour')
                  .subtract(sleepDurationMin, 'minute')
                  .format('MM/DD/YYYY HH:mm'),
          barEnd: barEndTime,
          type: dataSleepWeekly[i].type
        }
      )
    }

    dataChartSleepWeekly = this.addBlankDate(dataChartSleepWeekly)

    var sleepStartTimes = []
    var sleepEndTimes = []

    dataChartSleepWeekly.forEach(s => {
      sleepStartTimes.push(moment(new Date(s.barStart)))
      sleepEndTimes.push(moment(new Date(s.barEnd)))
    })

    minTime = moment.min(sleepStartTimes).subtract(1, 'hour')
    maxTime = moment.max(sleepEndTimes).add(1, 'hour')

    if (this.props.action) {
      action = this.props.action
    } else {
      action = ''
    }

    //todo: add goal stats to daily viz

    return (
      <div>
        <div
          id="switch-weeks"
          style={{
            width: '70%',
            marginLeft: '15%',
            marginRight: '15%'
          }}
        >
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="baseline"
            spacing={0}
          >
            <Grid item xs={2} />
            <Grid item xs={2}>
              <IconButton
                onClick={() => this.prevWeek()}
                disabled={this.state.isPaused}
                className="btn btn-default btn-style"
              >
                <ChevronLeftIcon style={{ fontSize: 30 }} />
              </IconButton>
            </Grid>
            <Grid item xs={4}>
              <span style={{ fontSize: 14 }}>
                {moment(new Date(this.state.yearweekNo))
                  .startOf('week')
                  .format('M/D')}{' '}
                -{' '}
                {moment(new Date(this.state.yearweekNo))
                  .endOf('week')
                  .format('M/D')}
              </span>
            </Grid>
            <Grid item xs={2}>
              <IconButton
                onClick={() => this.nextWeek()}
                disabled={this.state.isPaused}
                className="btn btn-default btn-style"
              >
                <ChevronRightIcon style={{ fontSize: 30 }} />
              </IconButton>
            </Grid>
            <Grid item xs={2}>
              {moment(new Date(this.state.yearweekNo))
                .endOf('week')
                .format('l') ===
              moment()
                .endOf('week')
                .format('l') ? (
                ''
              ) : (
                <Button
                  onClick={() => this.setToday()}
                  className={classes.icon}
                  size="small"
                >
                  <span style={{ fontSize: 10 }}>Today</span>
                </Button>
              )}
            </Grid>
          </Grid>
        </div>
        <div
          id="daily_sleep_chart_view"
          style={{
            position: 'relative',
            textAlign: 'center',
            marginLeft:
              -this.props.width * 0.07 +
              (window.innerWidth - this.props.width / 1.28) / 2
          }}
        >
          <OrdinalFrame
            size={[this.props.width / 1.28, this.props.height / 1.28]}
            data={dataChartSleepWeekly}
            rAccessor={d => new Date(d.barStart)}
            oAccessor={d => moment(new Date(d.date)).format('d')}
            sortO={(a, b) => a > b}
            rExtent={[minTime, maxTime]}
            type={{
              type: this.timelineSleep,
              rotate: 180
            }}
            projection="vertical"
            oPadding={this.props.width / 35}
            axis={[
              {
                orient: 'left',
                ticks: 7,
                tickFormat: d => (
                  <text
                    key={`tick-${d}`}
                    style={{ fill: '#cecece', textAnchor: 'end', fontSize: 10 }}
                    y={-2}
                  >
                    {moment(new Date(d)).format('h a')}
                  </text>
                ),
                tickValues: [
                  new Date(
                    moment(moment(new Date(this.state.yearweekNo)))
                      .day('monday')
                      .hour('0')
                      .minute('0')
                      .second('0')
                  ),
                  new Date(
                    moment(moment(new Date(this.state.yearweekNo)))
                      .day('monday')
                      .hour('2')
                      .minute('0')
                      .second('0')
                  ),
                  new Date(
                    moment(moment(new Date(this.state.yearweekNo)))
                      .day('monday')
                      .hour('4')
                      .minute('0')
                      .second('0')
                  ),
                  new Date(
                    moment(moment(new Date(this.state.yearweekNo)))
                      .day('monday')
                      .hour('6')
                      .minute('0')
                      .second('0')
                  ),
                  new Date(
                    moment(moment(new Date(this.state.yearweekNo)))
                      .day('monday')
                      .hour('8')
                      .minute('0')
                      .second('0')
                  ),
                  new Date(
                    moment(moment(new Date(this.state.yearweekNo)))
                      .day('monday')
                      .hour('10')
                      .minute('0')
                      .second('0')
                  ),
                  new Date(
                    moment(moment(new Date(this.state.yearweekNo)))
                      .day('monday')
                      .hour('12')
                      .minute('0')
                      .second('0')
                  ),
                  new Date(
                    moment(moment(new Date(this.state.yearweekNo)))
                      .day('monday')
                      .hour('14')
                      .minute('0')
                      .second('0')
                  ),
                  new Date(
                    moment(moment(new Date(this.state.yearweekNo)))
                      .day('monday')
                      .hour('16')
                      .minute('0')
                      .second('0')
                  ),
                  new Date(
                    moment(moment(new Date(this.state.yearweekNo)))
                      .day('monday')
                      .hour('18')
                      .minute('0')
                      .second('0')
                  ),
                  new Date(
                    moment(moment(new Date(this.state.yearweekNo)))
                      .day('monday')
                      .hour('20')
                      .minute('0')
                      .second('0')
                  ),
                  new Date(
                    moment(moment(new Date(this.state.yearweekNo)))
                      .day('monday')
                      .hour('22')
                      .minute('0')
                      .second('0')
                  )
                ],
                baseline: false,
                tickLineGenerator: ({ xy }) => (
                  <path
                    key={`tickLine-${xy.value}`}
                    style={{ stroke: '#F0F0F0 ' }}
                    d={`M${xy.x1},${xy.y1}L${xy.x2},${xy.y1}L${xy.x2},${
                      xy.y1
                    }L${xy.x1},${xy.y1}Z`}
                  />
                )
              }
            ]}
            margin={{
              left: this.props.width / 7.5,
              top: this.props.height / 24,
              right: this.props.width / 10.6,
              bottom: this.props.height / 9.6
            }}
            oLabel={d => (
              <text
                key={`label-${d}`}
                fill="#cecece"
                textAnchor="middle"
                fontSize={14}
              >
                {d === '0'
                  ? 'S'
                  : d === '1'
                    ? 'M'
                    : d === '2'
                      ? 'T'
                      : d === '3'
                        ? 'W'
                        : d === '4' ? 'T' : d === '5' ? 'F' : 'S'}
              </text>
            )}
            annotationSettings={{
              layout: {
                type: 'marginalia',
                orient: 'right',
                textPadding: this.props.width / 21
              }
            }}
            hoverAnnotation={false}
            tooltipContent={d => (
              <div
                key={`tooltip-${d.summary[0].renderKey}`}
                className={classes.tooltipContent}
              >
                <p key={`p-1`}>
                  {moment(new Date(d.pieces[0].date)).format('MM/DD/YYYY')}
                </p>
                <p key={`p-2`}>
                  Slept{' '}
                  {moment
                    .utc(
                      moment(
                        new Date(d.pieces[0].barEnd),
                        'MM/DD/YYYY HH:mm'
                      ).diff(
                        moment(
                          new Date(d.pieces[0].barStart),
                          'MM/DD/YYYY HH:mm'
                        )
                      )
                    )
                    .format('HH:mm')}:
                </p>
                <p key={`p-3`}>
                  - Slept at{' '}
                  {moment(new Date(d.pieces[0].barStart)).format('HH:mm A')}
                </p>
                <p key={`p-4`}>
                  - Got up at{' '}
                  {moment(new Date(d.pieces[0].barEnd)).format('HH:mm A')}
                </p>
              </div>
            )}
          />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ChartTypes/AlchemySleepWeekly.js